import React from 'react'

import { sharedData } from '../../../models/shared_data'
import { CurFormatComponent } from '../../shared/cur_format/cur_format.component'

export class OrderBonusApply extends React.Component {

  constructor(props) {
    super(props)

    this.useBonuses = this.useBonuses.bind(this)
    this.clearBonuses = this.clearBonuses.bind(this)
  }

  bonusNotAvailable() {
    return !sharedData.data.client || !sharedData.data.site_params.is_bonus_avaliable
  }

  haveNoBonuses() {
    return sharedData.data.client.bonuses <= 0
  }

  useBonuses(e) {
    e.preventDefault()
    const o = this.props.order
    this.props.changeBonus(o.maximum_bonus_spend)
  }

  clearBonuses(e) {
    e.preventDefault()
    this.props.changeBonus(0)
  }


  render() {
    if(this.bonusNotAvailable() || this.haveNoBonuses())
      return null
    const o = this.props.order
    return (
      <div className="bonus-apply">
        {o.bonus_sum == 0 &&
          <a href='' className="btn btn--blue" onClick={this.useBonuses}>
          Использовать бонусы
          &nbsp;
          <CurFormatComponent price={ o.maximum_bonus_spend }/>
          </a>
        }
        {o.bonus_sum > 0 &&
          <div>
            <span>Использовано
            &nbsp;
            <CurFormatComponent price={o.bonus_sum} />
            &nbsp;
            бонусов &nbsp;</span>
            <a href='' onClick={this.clearBonuses}>Отменить</a>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/order_bonus_apply.component.jsx